/*
 * Layout for the tenant user list
 */

define(["marionette", "./template/tenantUsersTemplate.html"], function (
  Marionette,
  TenantUsersTemplate,
) {
  "use strict";

  const TenantUsersView = {
    tenantUsersView: Marionette.Layout.extend({
      template: TenantUsersTemplate,
      triggers: {
        "click #addUser": "add:user",
      },
      regions: {
        tenantUsersList: "#tenantUsersList",
        tenantUserStatusFilter: "#tenantUserStatusFilter",
      },
    }),
  };

  return TenantUsersView;
});
